import { render, staticRenderFns } from "./Orbiter8Logo.svg.vue?vue&type=template&id=147ce298&"
import script from "./Orbiter8Logo.svg.vue?vue&type=script&lang=js&"
export * from "./Orbiter8Logo.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports